import Index from '@tunnel-components/@pages/supervision/camera/segmentation/home/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/camera/segmentation/onecamera/index.ts